import { deleteRequest, getRequest, postRequest, putRequest } from 'config/Axios/baseConfig';
import {
  SetupTimePayload,
  SetupTimeResponse,
  SetupTimeSingleResponse
} from 'Interfaces/ReferenceInterfaces/SetupTimeInterface';

export const setupTimeServices = {
  getAllSetupTimes: (page = 1, pageSize = 10000): Promise<SetupTimeResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<SetupTimeResponse>(
          `pps/setup-times?page=${page}&page_size=${pageSize}`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getSetupTimeById: (id: number): Promise<SetupTimeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<SetupTimeSingleResponse>(`pps/setup-times/${id}/`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createSetupTime: (setupTimeData: SetupTimePayload): Promise<SetupTimeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<SetupTimeSingleResponse>(
          'pps/setup-times/',
          setupTimeData
        );
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  updateSetupTime: (
    id: number,
    setupTimeData: SetupTimePayload
  ): Promise<SetupTimeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await putRequest<SetupTimeSingleResponse>(
          `pps/setup-times/${id}/`,
          setupTimeData
        );
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  deleteSetupTime: (id: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await deleteRequest(`pps/setup-times/${id}/`);
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  }
};
